(function (angular) {
    'use strict';

    angular.module('reports')

        .component('liveChatChannelSpread', {
            bindings: {
            },
            controller: ["$element", "liveChatService", function ($element, liveChatService) {
                var ctrl = this;

                /**
                 * 
                 * @param {*} timeline 
                 * @param {*} spreadData - {data: [...], labels: [...], colors: [...]}
                 */
                ctrl.updateData = function (data) {

                    var spreadData = data.channelSpread;

                    // recreate the graph if the channels have changed, otherwise just update the data ...
                    var create = false;
                    if (ctrl.spreadData) {
                        if (!angular.equals(ctrl.spreadData.labels, spreadData.labels)) {
                            create = true;
                        }
                    } else {
                        create = true;
                    }

                    if (create) {
                        if (ctrl.myChart) {
                            ctrl.myChart.destroy();
                        }

                        ctrl.myChart = new Chart(ctrl.ctx, {
                            type: 'pie',
                            data: {
                                labels: spreadData.labels,
                                datasets: [{
                                    data: spreadData.data,
                                    backgroundColor: spreadData.colors,
                                    label: 'Channel split',
                                }]
                            },
                            options: {
                                plugins: {
                                    datalabels: {
                                        display: false
                                    }
                                },
                                responsive: true,
                                legend: {
                                    position: "right",
                                    labels: {
                                        usePointStyle: true,
                                    },
                                    onClick: function (e) { e.stopPropagation() }
                                },
                                title: {
                                    display: true,
                                    text: 'Channel Breakdown'
                                },
                                animation: {
                                    animateScale: true,
                                    animateRotate: true
                                },
                                tooltips: {
                                    callbacks: {
                                        label: function (tooltipItem, data) {
                                            var dataset = data.datasets[tooltipItem.datasetIndex];
                                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                                return previousValue + currentValue;
                                            });
                                            var currentValue = dataset.data[tooltipItem.index];
                                            var percentage = Math.floor((currentValue / total) * 100);
                                            return data.labels[tooltipItem.index] + " " + currentValue + " (" + percentage + "%)";
                                        }
                                    }
                                }
                            }
                        });

                    } else if (!angular.equals(ctrl.myChart.data.datasets[0].data, spreadData.data)) {
                        ctrl.myChart.data.datasets[0].data = spreadData.data;
                        ctrl.myChart.update();
                    }

                    ctrl.spreadData = spreadData;
                }

                var listenerFunc = ctrl.updateData.bind(this);

                /**
                 * 
                 */
                ctrl.$onInit = function () {
                    var canvas = $element.find("canvas");
                    ctrl.ctx = canvas[0].getContext("2d");
                    liveChatService.addEventListener(listenerFunc);
                }

                /**
                 * 
                 */
                ctrl.$onDestroy = function () {
                    liveChatService.removeEventListener(listenerFunc);
                }

            }],
            template: '<div class="col-md-12"><canvas></canvas></div>'
        })

})(window.angular);